<ng-container>
  @if(!isFromVault) {
  <div [class]="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected ? 'mb-[42px]' : 'mb-[12px]'">
    <div class="m-0 flex items-start flex-col gap-[8px]">
      <span
        class="text-[#53565B] text-xl font-semibold font-open-sans"
        *ngIf="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
      >
        Do you want to
        <span class="text-[#25508E] font-bold">Share {{ userObject.nick_name ?? personalVaultName ?? stateObject.name }}’s Vault</span>?
      </span>

      <span
        class="text-[#53565B] text-xl font-semibold font-open-sans"
        *ngIf="this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
      >
        Manage <span class="text-[#25508E] font-bold">Sharing</span> for
        <span class="text-[#25508E] font-bold">{{ userObject.nick_name ?? personalVaultName ?? stateObject.name }}’s Vault</span>
      </span>

      <span
        class="text-[#18191C] font-open-sans font-normal text-sm"
        *ngIf="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected && !nonProfessionalUsers?.length && !isVaultSetupLoading"
      >
        If vault level sharing is not needed, you will have the ability to share individual items in future steps as necessary.
      </span>
    </div>
  </div>

  <div
    class="flex flex-col gap-5 w-[291px]"
    *ngIf="!this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected && !nonProfessionalUsers?.length && !isVaultSetupLoading"
  >
    <div
      [class]="option?.isSelected ? 'app__discovery-option-form-selected ' : 'app__discovery-option-form'"
      *ngFor="let option of options"
      (click)="handleSubFlow(option.value, level)"
    >
      <span class="text-[20px] m-0 font-open-sans text-[#53565B] font-semibold leading-[22.5px]">
        {{ option.value }}
      </span>
    </div>
  </div>
  }

  <div *ngIf="isVaultSetupLoading">
    <vault-setup-loading [text]="'One moment while we check for existing users you have shared with'"></vault-setup-loading>
  </div>

  <div *ngIf="!isVaultSetupLoading">
    <!-- Search Sharing  -->
    <div class="form-group form-main form-group-overrides w-full mb-0">
      <div class="div-group w-full" style="display: flex; justify-content: center; align-items: center">
        <div
          class="w-full"
          *ngIf="allUserConnections && allUserConnections.length > 0 && this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected"
        >
          <manage-users
            [data]="allUserConnections"
            placeHolder="Search Connections"
            (selectConnectedUser)="selectConnectedUser($event)"
            [selectedUsers]="nonProfessionalUsers"
            [isBalanceSheetMember]="true"
            [isShowFooter]="true"
            [isInputFullWidth]="true"
          ></manage-users>
        </div>
      </div>
    </div>

    <!-- No Sharing to Show -->
    <div
      class="width-100per"
      [ngClass]="{ 'mt-[4px]': isFromVault, 'mt-[30px]': !isFromVault }"
      *ngIf="
        (!nonProfessionalUsers || nonProfessionalUsers?.length === 0) && this.stepInfo[this.selectedVaultType][this.selectedIndex].isAnswerSelected
      "
    >
      <div class="flex-center"><img src="assets/images/sharing_big_empty_state.svg" /></div>
      <span class="flex-center font-sans font-semibold text-lg" [ngClass]="{ 'mt-[24px]': isFromVault, 'mt-8': !isFromVault }" style="color: #53565b">
        <span *ngIf="!isFromVault">{{ userObject.nick_name ?? personalVaultName ?? stateObject.name }}’s</span
        ><span *ngIf="isFromVault">This</span>&nbsp;Vault has not been&nbsp;<span class="font-bold" style="color: #25508e">shared</span></span
      >
    </div>

    <!-- Sharing Data To show -->

    <div class="overflow-sheet-member mt-[12px]" *ngIf="nonProfessionalUsers?.length">
      <div class="w-full d-flex text-sm font-sans font-semibold">
        Sharing &nbsp;<span class="text-[#25508E] font-bold">({{ nonProfessionalUsers?.length }})</span>
      </div>

      <div class="member-infos mt-3 width-100per">
        <div
          class="member-infos--left w-100per"
          [ngStyle]="{
            'max-height': switchFromUser ? (isFromVault ? '250px' : 'calc(100vh - 486px)') : isFromVault ? '250px' : 'calc(100vh - 434px)',
            'max-width':
              isFromVault && nonProfessionalUsers?.length > 2 ? 'calc(100% + 20px)' : isFromVault && nonProfessionalUsers?.length < 3 ? '100%' : ''
          }"
        >
          <div
            *ngFor="let user of nonProfessionalUsers; let i = index"
            [ngStyle]="{
              'max-width':
                nonProfessionalUsers?.length > 2 && isFromVault
                  ? 'calc(100% - 16px)'
                  : isFromVault && nonProfessionalUsers?.length < 3
                  ? '100% '
                  : '',
              'margin-top': i == 0 ? '0px' : '16px'
            }"
            class="flex fl-al-center fl-justify-between w-100per mobile-member-item-view member-infos--add"
          >
            <div class="selected-client-wrapper">
              <div class="flex fl-al-center mobile-view-wrapper" *ngIf="user?.memberUser?.name">
                <div *ngIf="user?.memberUser?.isGroup">
                  <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                </div>
                <ngx-avatars
                  *ngIf="!user?.memberUser?.isGroup"
                  size="50"
                  src="{{ user?.memberUser?.user_profile_image_url }}"
                  name="{{ user?.memberUser?.name }}"
                  [round]="true"
                  initialsSize="2"
                ></ngx-avatars>

                <div class="flex fl-col gap-[2px] ml-[8px]">
                  <span class="new-member-infos--name">{{ user?.memberUser?.name }}</span>
                  <span class="new-member-infos--subname">{{ user?.memberUser?.relationship_name }}</span>
                </div>
              </div>

              <div class="flex fl-al-center mobile-view-wrapper" *ngIf="user?.user_first_name">
                <div *ngIf="user?.isGroup">
                  <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                </div>

                <ngx-avatars
                  *ngIf="!user?.isGroup"
                  size="50"
                  src="{{ user?.user_profile_image_url }}"
                  name="{{ user?.user_first_name + ' ' + user?.user_last_name }}"
                  [round]="true"
                  initialsSize="2"
                ></ngx-avatars>

                <!-- <ngx-avatars *ngIf="user?.user_profile_image_url" size="50"
                  src="{{ user?.user_profile_image_url }}" name="{{user?.user_first_name }}" [round]="true"
                  initialsSize="2"></ngx-avatars> -->

                <div class="flex fl-col gap-[2px] ml-[8px]">
                  <span class="new-member-infos--name">{{ user?.user_first_name }} {{ user?.user_last_name }}</span>
                  <!-- <span class="new-member-infos--subname">{{ user?.relationship_name }}</span> -->
                </div>
              </div>
            </div>

            <div class="member-infos--trash flex-center pointer shareTypeSelection">
              <span class="app__centered-item shareTypeText" style="margin-top: 6px">
                <span
                  class="flex fl-justify-center fl-al-center"
                  style="min-width: 32px"
                  [ngClass]="user.vault_user_share_is_sealed ? 'eve-icon' : ''"
                >
                  @if (user.vault_user_share_is_sealed) {
                  <mat-icon>notifications</mat-icon>
                  }
                </span>
                <button [class]="checkAccessibility(user?.vault_user_share_share_date)">
                  {{ checkAccessibilityTag(user?.vault_user_share_share_date) }}
                  @if (checkAccessibilityTag(user?.vault_user_share_share_date) == '') {
                  <span>&nbsp;{{ user?.vault_user_share_share_date | date }}</span>
                  }
                </button>
                <!-- <img
                style="margin-left: 21px; cursor: pointer"
                src="../../../../../assets/images/editSharingIcon.svg"
                class="shared-img-icon"
                (click)="shareTypeSelectionClicked()"
                /> -->
              </span>

              <!-- <span class="mr-[16px]"><img src="assets/images/vault_setup/notification-blue.svg" /></span>
              <span
                class="mr-[16px] w-[115px] h-[26px] flex-center bg-[#EEFBF7] text-[#2ECF99] font-bold font-open-sans text-xs">Now</span> -->
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon class="menu">more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="shareTypeSelectionClicked(user)">
                  <mat-icon height="20px" style="color: #25508e; margin-right: 8px">edit</mat-icon>
                  <span class="text-xs font-semibold" style="color: #18191c">Edit</span>
                </button>
                <button mat-menu-item (click)="deleteSharing(user, true)">
                  <mat-icon height="20px" style="color: #eb5757; margin-right: 8px">delete</mat-icon>
                  <span class="text-xs font-semibold" style="color: #eb5757">Remove</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
